/* @flow */

import { toJS, observable, computed, action } from 'mobx';

import { ApiModel } from 'api/ApiModel';

export default class ContractStore extends ApiModel {
  @observable selectedContractId: string;
  @observable contractActivityData: ?Array<*>;
  @observable loading: boolean = true;
  @observable contract: Object;
  @observable documents: Array = [];
  @observable COCDocuments: Array = [
    {
      name: 'Certificate of Conformance',
      type: 'pdf',
    },
  ];

  @computed get usersByRole(): Object {
    return this.contract
      ? this.contract.users.reduce(
          (map: *, user: *) => ({
            ...map,
            [user.role]: map[user.role] ? [...map[user.role], user] : [user],
          }),
          {}
        )
      : {};
  }

  @computed get roles(): Array<number> {
    return Object.keys(toJS(this.usersByRole));
  }

  @computed get getDocuments() {
    const documents = this.documents;
    return documents.map(file => {
      return {
        id: file.id,
        name: file.name,
        type: file.type,
        showType: false,
        icon: '#icon-contracts',
        created_at: file.created_at,
        folderId: this.contract.id,
        link: `contracts/${this.contract.id}/documents/${file.id}`,
        onDelete: this.onDeleteFile.bind(this),
      };
    });
  }

  @computed get getCOCDocuments() {
    return this.COCDocuments.map(file => {
      return {
        name: file.name,
        type: file.type,
        showType: true,
        icon: '#icon-contracts',
        folderId: this.contract.id,
        link: `contracts/${this.contract.id}/certificate-of-conformance/download`,
      };
    });
  }

  @action
  async loadContract(id: string): Promise<void> {
    this.loading = true;

    this.contract = await this.api.getResource('contracts/' + id);

    this.loading = false;
  }

  @action
  async loadDocuments(id: string): Promise<void> {
    this.loading = true;

    this.documents = await this.api.getResource(`contracts/${id}/documents`);

    this.loading = false;
  }

  @action
  async onDeleteFile(contractId, fileId) {
    try {
      const url = `contracts/${this.contract.id}/documents/${fileId}`;
      const res = await this.api.deleteResource(url);

      this.documents = res.original.data;
    } catch (e) {
      console.log(e, 'catching ERRORS');
    }
  }

  extendContract = (contract: *) => {
    return this.api.createResource(
      'contracts/' + this.selectedContractId + '/asset-rental-request',
      contract
    );
  };
}
